/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars,faPlay, faPenToSquare, faCircleXmark, faChevronRight, faChevronLeft, faMagnifyingGlass, faPlus, faSortUp,faSortDown, faFileArrowDown, faArrowRight, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearData, deleteContactRequest, getContactRequest } from '../../../redux/modules/contacts/contactSlice';
import { RootState } from '../../../redux/rootReducer';
import { toast } from 'react-toastify';
import { columnTypes, Contact, Filter, FilterOperator, FilterOption, PermissionObject } from '../../../redux/modules/auth/types';
import { Alert, Button, Col, Form, Modal,OverlayTrigger,Row,Table, Tooltip} from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { addListParams } from '../../../redux/modules/lists/types';
import { addListsRequest, clearListData } from '../../../redux/modules/lists/listsSlice';
import XDeleteModal from '../../../component/modal/XDeleteModal';
import useSidebar from '../../../hooks/useSidebar';
import useList from '../../../hooks/useList';
import Select from 'react-select';
import PaginationNav from '../../../component/pagination/pagination';
import XButton from '../../../component/button/XButton';
import { XModal } from '../../../component';
import { addContactRequest } from '../../../redux/modules/contacts/contactSlice';
import XLoader from '../../../component/loader/XLoader';
import { toaster } from '../../../utils/toast';
import { getPredefinedFieldRequest } from '../../../redux/modules/settings/settingsSlice';
import { downloadCsv } from "../../../utils/helper";
import useAxios from '../../../hooks/useAxios';
import { API_ENDPOINTS } from '../../../constants/api';
import XConfirm from '../../../component/confirm/XConfirm';
import { CampaignType } from '../../../utils/enums';
import useUploadProgress from '../../../hooks/useUploadProgress';

interface ContactsProps {
  permission?: PermissionObject
}

const LAST_CONTACT_ADDED_FILTER = 'LastContactAdded';

const AllContacts: React.FC<ContactsProps> = (props) => {
  const { permission } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { errorRes ,successRes ,listRes, loading: listLoading} = useSelector((state: RootState) => state.lists);
  const { contactlist, loading: contactLoading, addedContact, deletedContact, error} = useSelector((state: RootState) => state.contactlist);
  const [show, setShow] = useState(false);
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const [showCreateListModel, setShowCreateListModel] = useState(false);
  const [showExistingListModel, setShowExistingListModel] = useState(false);
  const [existingListProgress, setExistingListProgress] = useState(0);
  const [isExistingListSubmitting, setIsExistingListSubmitting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [queryParams, setQueryParams] = useState({
    search: '',
    page: 1,
    limit: 10,
    filters: [] as Filter[],
  });
  const initialFilter: Filter = {
    selectedFilter: 'Select',
    selectedOperator: 'Select',
    inputValue: '',
    logicalOperator: null,
  };
  const [filters, setFilters] = useState<Filter[]>([initialFilter]);
  const [sortColumn, setSortColumn] = useState<string | null>(null);
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');
  const [checkedItems, setCheckedItems] = useState<string[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [selectedListId, setSelectedListId] = useState<any>([]);
  const [existingContacts, setExistingContacts] = useState<any>([]);
  const [createOrExitsList, setCreateOrExitsList] = useState<string>('CREATE');
  const [selectedUser, setSelectedUser] = useState<Contact| null>(null);
  const { onShowSidebar } = useSidebar();
  const [selectAll, setSelectAll] = useState<any>(false);
  const { listMap } = useList()
  const [showUploadContactsModel, setShowUploadContactsModel] = useState(false);
  const [csvFile, setCsvFile] = useState<File | null>(null);
  const { predefinedFieldList } = useSelector((state: RootState) => state.settings);
  const { postData, isLoading, fetchData } = useAxios();
  const [unsubscribeModal, setUnsubscribeModal] = useState<boolean>(false);
  const [selectedUnsubscribe, setSelectedUnsubscribe] = useState<any>({
    campaignType: '',
    contactId: ''
  });
  const [contactSubscribeStatus, setContactSubscribeStatus] = useState<boolean>(false)
  const { smsFeature, selectedLocationId } = useSelector((state: RootState) => state.user);
  const [csvFields, setCsvFields] = useState<string[]>([]);
  const [existingFields, setExistingFields] = useState<string[]>([]);
  const [preselectedValue, setPreselectedValue] = useState<{ csvField: string; databaseField: string }[]>([]);
  const [showCustomFieldsModal, setShowCustomFieldsModal] = useState(false);
  const [showCsvConfirmModal, setShowCsvConfirmModal] = useState(false);
  const [brands, setBrands] = useState([]);
  const [expandedEmails, setExpandedEmails] = useState<string[]>([]);
  const fileInputRef = React.useRef<HTMLInputElement | null>(null);

  const unmappedFields = csvFields.filter((_: any, index: number) => {
    const mapped = preselectedValue[index];
    return !mapped || !mapped.databaseField || mapped.databaseField.trim() === "";
  });

  const {
    progress: uploadProgress,
    isUploading,
    startUpload,
    resetUpload,
  } = useUploadProgress({
    isLoading: contactLoading,
    isSuccess: Boolean(addedContact && addedContact.success === true),
    isError: Boolean(error && error.success === false),
    fileSize: csvFile?.size,
  });

  const resetCsvUploadState = () => {
    setCsvFile(null);
    setCsvFields([]);
    setPreselectedValue([]);
    setExistingFields([]);
    setShowCsvConfirmModal(false);
    resetUpload();
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  useEffect(() => {
    fetchBrandsList();
    dispatch(getPredefinedFieldRequest());
    dispatch(getContactRequest(queryParams));
    const totalContacts = contactlist?.totalCount;
    const totalPages = Math.ceil(totalContacts / queryParams?.limit);
    setTotalPages(totalPages);
  }, [queryParams, contactlist?.totalCount, selectedLocationId])

    useEffect(() => {
      if (deletedContact && deletedContact.success === true) {
        toast(deletedContact.message);
        dispatch(getContactRequest(queryParams));
      }
      else if (error && error.success === false) {
        toaster({success: false, message: error.message});
      }
      dispatch(clearData());
    }, [error, deletedContact,queryParams])

    useEffect(() => {
      if (addedContact && addedContact.success === true) {
        toast(addedContact.message);
        if (isUploading) {
          setTimeout(() => {
            setShowUploadContactsModel(false);
            resetCsvUploadState();
          }, 750);
        } else {
          setShowUploadContactsModel(false);
          resetCsvUploadState();
        }
        dispatch(getContactRequest(queryParams));
      }
      else if (error && error.success === false) {
        toaster({success: false, message: error.message});
        resetUpload();
      }
      dispatch(clearData());
    }, [error, addedContact])

  const handlePageChange = (pageNumber: number) => {
    setQueryParams((prevParams) => ({ ...prevParams, page: pageNumber }));
  };

  const handleSearchChange = (searchValue: string): void => {
    setQueryParams((prevParams) => ({ ...prevParams, page: 1, search: searchValue }));

  };

  const handleSortClick = (column: string) => {
    if (sortColumn === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortOrder('asc');
    }
  };

  const sortedContacts = [...(contactlist?.contactList || [])].sort((a, b) => {
    if (sortColumn) {
      const aValue = a[sortColumn];
      const bValue = b[sortColumn];
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return sortOrder === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
      }
    }
    return 0;
  });

  const handleEditClick =(contactId: string)=>{
    const encryptedContactId = contactId
  navigate(`/org/edit-contact/${encodeURIComponent(encryptedContactId)}`);
  }

  const handleAdvanceSearchShow = () => {
    setAdvanceSearch(true)
  };
  const handleAdvanceSearchClose=()=>{
    resetFilters();
    setAdvanceSearch(false);
  }

  const resetFilters = () => {
    setFilters([initialFilter]);
  };

  const handleContactDetailClick = (contactId: string) => {
    const encryptedContactId = contactId
    navigate(`/org/contact-detail/${encodeURIComponent(encryptedContactId)}`)
  }

  const handleFilterChange = (
    index: number,
    property: keyof Filter,
    value: string | FilterOption | FilterOperator | 'AND' | 'OR'
  ) => {
    const updatedFilters = [...filters];
      if (index === 0) {
      updatedFilters[index].logicalOperator = null;
    } else {
      updatedFilters[index].logicalOperator = updatedFilters[index - 1].logicalOperator;
    }
    updatedFilters[index][property] = value as never;
    setFilters(updatedFilters);
    // setQueryParams((prevParams) => ({...prevParams, filters: updatedFilters }));
  };
  
  const addFilter = () => {
    setFilters((prevFilters) => [
      ...prevFilters,
      {
        selectedFilter: 'Select',
    selectedOperator: 'Select',
    inputValue: '',
    logicalOperator: 'AND',
      },
    ]);
  };

  
  const removeFilter = (index: number) => {
    const updatedFilters = [...filters];
    if (index > 0 && updatedFilters[index].logicalOperator != null) {
      updatedFilters[index - 1].logicalOperator = updatedFilters[index].logicalOperator as 'AND' | 'OR';
    }
    updatedFilters[index].logicalOperator = null;//added
    updatedFilters.splice(index, 1);
    setFilters(updatedFilters);
    setQueryParams((prevParams) => ({...prevParams, filters: updatedFilters }));
  };
  const handleAdvanceSearch = () => {
    setQueryParams((prevParams) => ({...prevParams, filters: filters }));
    dispatch(getContactRequest(queryParams)); 
    handleAdvanceSearchClose();
  };

  const handleCheckboxChange = (id: string) => {
    setCheckedItems((prevCheckedItems) => {
      const updatedCheckedItems = prevCheckedItems.includes(id)
        ? prevCheckedItems.filter((item) => item !== id)
        : [...prevCheckedItems, id];
  
      const allContactIds = sortedContacts.map((contact) => contact.id);
      const isAllChecked = allContactIds.every((contactId) => updatedCheckedItems.includes(contactId));
      setSelectAll(isAllChecked || false);
      return updatedCheckedItems;
    });
  };
  const handleList = (type: string) => {
    setCreateOrExitsList(type)
    type === 'CREATE' ? setShowCreateListModel(true) : setShowExistingListModel(true)
    const modifiedArray = checkedItems.map((value, index) => ({
      id: index,
      value: value,
    }));
    setSelectedOptions(modifiedArray)
  };

  const validationSchema = Yup.object({
    listName: Yup.string().trim().required('List name is required').test(
      (value) => value.trim() !== ''
    ),
  });

  const formik = useFormik<addListParams>({
    initialValues: {
      listName: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values: addListParams) => {
      if(createOrExitsList === 'CREATE'){
        const payload={
          ...values,
          selectedOptions,
          update_id:'',
        }
        dispatch(addListsRequest(payload));
      }  
    },
  });

  const customFieldValidationSchema = Yup.object({
    customFields: Yup.array().of(
      Yup.object().shape({
        columnName: Yup.string().trim()
          .required('Column Name is required')
          .matches(/^[A-Za-z_0-9 ]*$/, 'Column Name can only contain letters, space and underscores')
          .matches(/^[^0-9]*$/, 'Column Name cannot contain numbers'),
        columnType: Yup.string().required('Column Type is required'),
      })
    ),
  });

  const customFieldsFormik = useFormik({
    initialValues: {
      customFields: [{ columnName: '', columnType: '' }]
    },
    validationSchema: customFieldValidationSchema,
    onSubmit: async (values) => {
      const { message, success } = await postData(API_ENDPOINTS.ADD_CUSTOM_FIELD, values);
      toaster({ message, success });
      if (success) {
        setShowCustomFieldsModal(false);
        await getPredefinedAndCustomFieldsName()
        customFieldsFormik.resetForm();
      }
    },
  });

  const existingListFormik = useFormik<any>({
    initialValues: {
      listName: ''
    },
    onSubmit: async (values: any) => {
      const newContacts = selectedOptions.filter((option:any) => (
        !existingContacts.some((contact:any) => contact.value === option.value)
      ));
      const updatedContacts = [...existingContacts, ...newContacts];
      if(createOrExitsList === 'EXISTING'){
          const payload={
          ...values,
          selectedOptions: updatedContacts,
          update_id: selectedListId,
          addToExitingList:true
        }
        dispatch(addListsRequest(payload));
      }
    },
  });

  const handleProceedUploadContacts = () => {
    setShowCsvConfirmModal(false);
    if (csvFile) {
      const hasEmailMapping = preselectedValue?.some(
        (item) => item.databaseField && item.databaseField.trim().toLowerCase() === 'email'
      );
      if (!hasEmailMapping) {
        toaster({
          success: false,
          message: 'Email field mapping is required to import contacts.',
        });
        return;
      }
      const brand = uploadContactsFormik.values.brand;
      const formData = new FormData();
      formData.append('csvFile', csvFile);
      formData.append('brand', brand);
      formData.append('mappedData', JSON.stringify(preselectedValue));
      startUpload();
      dispatch(addContactRequest({ data: formData }));
    }
  };

  const uploadContactsFormik = useFormik<any>({
    initialValues: {},
    onSubmit: async () => {
      if (!csvFile) {
        toaster({ success: false, message: 'Please select a CSV file to upload' });
        return;
      }
      const hasEmailMapping = preselectedValue?.some(
        (item) => item.databaseField && item.databaseField.trim().toLowerCase() === 'email'
      );
      if (!hasEmailMapping) {
        toaster({
          success: false,
          message: 'Email field mapping is required to import contacts.',
        });
        return;
      }
      setShowCsvConfirmModal(true);
    }
  });

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (listLoading && showExistingListModel) {
      setIsExistingListSubmitting(true);
      setExistingListProgress(10);
      interval = setInterval(() => {
        setExistingListProgress((prev) => (prev >= 95 ? 95 : prev + Math.max(1, Math.floor((96 - prev) * 0.15))));
      }, 200);
    } else if (!listLoading && !successRes) {
      setIsExistingListSubmitting(false);
      setExistingListProgress(0);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [listLoading, showExistingListModel, successRes]);

  useEffect(() => {
    if(successRes === true) {
      if (isExistingListSubmitting) {
        setExistingListProgress(100);
        setTimeout(() => {
          setShowCreateListModel(false);
          setShowExistingListModel(false);
          setIsExistingListSubmitting(false);
          setExistingListProgress(0);
        }, 400);
      } else {
        setShowCreateListModel(false);
        setShowExistingListModel(false);
      }
      toast(listRes.message);
      formik.resetForm();
    }
    if (errorRes) {
      toaster({success: false, message: errorRes.message});
      setIsExistingListSubmitting(false);
      setExistingListProgress(0);
    }
    dispatch(clearListData());
  }, [successRes ,errorRes])

  const handleDeleteContact = (contactId: string) => {
    dispatch(deleteContactRequest(contactId));
    
};
  const handleDeleteIconClick = (contact:any) => {
    setSelectedUser(contact);
    setShowDeleteModal(true);
  };

  const handleSelectAllChange = () => {
    if (selectAll) {
      setCheckedItems([]);
    } else {
      const allContactIds = sortedContacts.map((contact) => contact.id);
      setCheckedItems(allContactIds);
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    const normalizedExistingFields = existingFields.map((field:any) =>
      field.toLowerCase().replace(/_/g, "").replace(/\s+/g, "")
    );

    const normalizedCsvFields = csvFields.map((field:any) =>
      field.toLowerCase().replace(/_/g, "").replace(/\s+/g, "")
    );

    const matchedFields = csvFields.map((csvField:any, index:any) => {
      const normalizedCsvField = normalizedCsvFields[index];
      const matchIndex = normalizedExistingFields.findIndex(
        (existingField:any) => existingField === normalizedCsvField
      );

      if (matchIndex !== -1) {
        return {
          databaseField: existingFields[matchIndex],
          csvField,
        };
      } else {
        return {
          databaseField: "",
          csvField,
        };
      }
    });

    setPreselectedValue(matchedFields);
  }, [existingFields, csvFields]);

  const handleFileChange = (input: HTMLInputElement) => {
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      setCsvFields([]);
      setExistingFields([]);
      setPreselectedValue([]);
      
      if (file.size > 52428800) {
        toaster({ success: false, message: "File size exceeds the 50MB limit. Please upload a smaller CSV file." });
        if (input) input.value = '';
        setCsvFile(null);
        setCsvFields([]);
        return;
      }

      const reader = new FileReader();

        reader.onload = async () => {
          await getPredefinedAndCustomFieldsName();
          const result = reader.result as string;
          const lines = result.split("\n");
          const headers = lines[0].split(",").map(header => header.trim().replace(/^["']|["']$/g, ''));
          setCsvFields(headers);
          setCsvFile(file);
        };

      reader.onerror = () => {
        toaster({ success: false, message: "Unable to read the selected CSV file." });
        setCsvFile(null);
        setCsvFields([]);
        setExistingFields([]);
        setPreselectedValue([]);
        input.value = '';
      };

      // Slice first 64KB to read headers quickly without loading entire multi-megabyte file into memory
      reader.readAsText(file.slice(0, 65536));
    }
 };

 const handleFieldChange = (csvField: string, selectedDatabaseField: string, index: number) => {
  setPreselectedValue((prevValues: any) => {
    // Copy the existing array
    const updatedValues = [...prevValues];

    // Update the mapping for the specific index
    updatedValues[index] = { csvField, databaseField: selectedDatabaseField };

    return updatedValues;
  });
};

const getPredefinedAndCustomFieldsName = async () => {
  const response = await fetchData(API_ENDPOINTS.GET_PREDEFINED_FILEDS);
  if (response.success) {
    const predefinedFields = response.data.predefinedFields || [];
    const extractedCustomFields = response.data.customFields.map((field:any) => ({
      name: field.name,
      type: field.type === "text" ? "character varying" : field.type,
    }));
    
    const combinedNames = [
      ...predefinedFields.map((field: any) => field.name),
      ...extractedCustomFields.map((field: any) => field.name),
    ];

    setExistingFields(combinedNames);
  } else {
    setExistingFields([]);
  }
}

 const handleAddContactType = (value:any) => {
  if(value === 1) {
    navigate('/org/addContact')
  } else {
    resetCsvUploadState();
    setShowUploadContactsModel(true)
    setShow(false)
  }
 }

 const downloadCsvFormat = () => {
  downloadCsv(predefinedFieldList)
 };

 const onToggleChange = async (campaignType: string, contactId: string) => {
  setSelectedUnsubscribe({campaignType, contactId})
  setUnsubscribeModal(true)
};

const onUnsubscribeSubmit = async () => {
  const response = await postData(API_ENDPOINTS.TOGGLE_UNSUBSCRIBE, selectedUnsubscribe);
  const { message, success } = response;
  toaster({message, success})
  setUnsubscribeModal(false)
  dispatch(getContactRequest(queryParams));
}

const fetchBrandsList = async () => {
  const response = await fetchData(API_ENDPOINTS.GET_ALL_BRANDS);
  const formattedOption = response?.data?.brands?.map((v: any) => ({
    value: v.id,
    text: v.display_name,
    key: v.display_name,
  }));
  setBrands(formattedOption);
};

  const toggleEmailExpansion = (id: string) => {
    setExpandedEmails(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  return (
    <div>
      <div className="main-title d-flex align-items-center justify-content-between">
        <h2 className='d-flex align-items-center'>
          <span className="d-lg-none cursor-pointer" onClick={()=>onShowSidebar()}><FontAwesomeIcon icon={faBars} /></span>Contacts</h2>
        <div className="rt-btns">
          {(permission?.edit) && (
            <Button
              variant="primary"
              type="submit"
              className="btn-theme"
              onClick={() => {
                setShow(true)
              }} 
            >Add Contact
            </Button>
          )}
          <Button
              variant="primary"
              type="submit"
              className="btn-theme"
              onClick={handleAdvanceSearchShow}
            >Advanced Search
            </Button>
          {checkedItems && checkedItems.length > 0 && <>
          <Button
                variant="primary"
                type="submit"
                className="btn-theme"
                onClick={() => handleList("CREATE")}
              >Create New List
              </Button>
              <Button
                variant="primary"
                type="submit"
                className="btn-theme"
                onClick={() => handleList('EXISTING')}
              >Add To Existing List
              </Button>
          </>}
        </div>
      </div>
      <div className="filter-bar d-flex justify-content-between align-items-center">
        <div className='position-relative search-bar'>
          <Form.Control
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={queryParams.search}
            onChange={(e) => handleSearchChange(e.target.value)}
          />
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </div>
            {checkedItems.length > 0 && <p>{checkedItems.length} record(s) selected</p>}
          </div>

      <div className="table-listing contact-list all-contacts position-relative">
        <Table responsive>
          <thead>
            <tr>
              <th className='d-flex'>
                <Form.Group controlId="formBasicCheckbox">
                  <Form.Check 
                    type="checkbox" 
                    checked={selectAll} 
                    onChange={handleSelectAllChange}
                    ref={(input: any) => {
                      if (input) {
                        input.indeterminate = checkedItems.length > 0 && checkedItems.length < sortedContacts.length;
                      }
                    }}
                  />
                </Form.Group>
                Email Address
              </th>
              <th onClick={() => handleSortClick('firstname')}>First Name {sortColumn === "firstname" && <FontAwesomeIcon
               icon={sortOrder === "asc" ? faSortUp : faSortDown}/>}</th>
              <th onClick={() => handleSortClick('lastname')}>Last Name {sortColumn === "lastname" && <FontAwesomeIcon 
              icon= {sortOrder === "asc" ? faSortUp : faSortDown}/>}</th>
              <th>Address </th>
              <th>Phone Number </th>
              <th>DOB </th>
              <th>Tags </th>
              <th>Email Unsubscribe </th>
              {smsFeature && <th>SMS Unsubscribe</th>}
              <th>Actions </th>
            </tr>
          </thead>
            
          <tbody>
            {!contactLoading && sortedContacts?.length === 0 &&
              <tr>
                <td colSpan={9}>
                  <p className='text-center no-records'>No contact found.</p>
                </td>
              </tr>
            }
            {!contactLoading && sortedContacts && sortedContacts?.map((contact: Contact) => (
              <tr key={contact.id}>
                <td className='d-flex'>
                  <Form.Group controlId="formBasicCheckbox">
                    <Form.Check type="checkbox" key={contact.id}
                     checked={checkedItems.includes(contact.id)}
                     onChange={() => handleCheckboxChange(contact.id)}
                    />
                  </Form.Group>
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="tooltip-bottom">Click here to view details for "{contact.email}"</Tooltip>}
                  >
                    <span 
                      className={`d-inline-block cursor-pointer ${expandedEmails.includes(contact.id) ? '' : 'text-truncate'}`} 
                      style={{
                        maxWidth: expandedEmails.includes(contact.id) ? '100%' : '150px',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        backgroundColor: expandedEmails.includes(contact.id) ? '#f1f1f1' : 'transparent',
                        padding: expandedEmails.includes(contact.id) ? '7px 15px' : '0',
                        borderRadius: '30px',
                        userSelect: expandedEmails.includes(contact.id) ? 'text' : 'none'
                      }}
                      onClick={() => handleContactDetailClick(contact.id)}
                    >
                      {contact.email}
                    </span>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="tooltip-bottom">Expand/collapse email address.</Tooltip>}
                  >
                    <FontAwesomeIcon 
                    icon={expandedEmails.includes(contact.id) ? faChevronLeft : faChevronRight} 
                    className={`ms-2 cursor-pointer ${expandedEmails.includes(contact.id) ? 'mt-2' : 'mt-1'}`}
                    onClick={() => toggleEmailExpansion(contact.id)}/>
                  </OverlayTrigger>
                </td>
                <td>{contact.firstname}</td>
                <td>{contact.lastname}</td>
                <td>{contact.address}</td>
                <td>{contact.phone_number}</td>
                <td>{contact.DOB !== null ? new Date(contact.DOB).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' }) : ''}</td>
                <td>
                  {contact && contact?.tags?.map((tag, index) => (
                    <span key={index} className={tag?.name && 'tag-name'}>{tag?.name}</span>
                  ))}
                </td>
                <td>
                  <Form.Check
                    name={CampaignType.EMAIL}
                    type="switch"
                    id="custom-switch"
                    checked={contact.unsubscribe}
                    onChange={() => {
                      onToggleChange(CampaignType.EMAIL, contact.id)
                      setContactSubscribeStatus(contact.unsubscribe)
                    }}
                  />
                </td>
                {smsFeature &&
                  <td>
                    <Form.Check
                      name={CampaignType.SMS}
                      type="switch"
                      id="custom-switch"
                      checked={contact.sms_unsubscribe}
                      onChange={() => {
                        onToggleChange(CampaignType.SMS, contact.id)
                        setContactSubscribeStatus(contact.sms_unsubscribe)
                      }}
                    />
                  </td>
                }
                <td className='actions'>
                  {(permission?.delete) && (
                    <span><FontAwesomeIcon icon={faCircleXmark} 
                    onClick={() => handleDeleteIconClick(contact)}
                    /></span>
                  )}
                  {(permission?.edit) && (        
                    <span><FontAwesomeIcon icon={faPenToSquare} onClick={() => handleEditClick(contact.id)}/></span>
                  )}
                  </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {contactLoading && <XLoader />}
        <XConfirm
          message={`Are you sure you want to ${contactSubscribeStatus ? "subscribe" : "unsubscribe"} ${selectedUnsubscribe.campaignType}?`}
          show={unsubscribeModal}
          onCancel={() => setUnsubscribeModal(false)}
          onConfirm={onUnsubscribeSubmit}
          isLoading={isLoading}
        />
        <XDeleteModal
                  show={showDeleteModal}
                  handleClose={() => setShowDeleteModal(false)}
                  title="Delete Contact"
                  body={`Are you sure you want to delete the Contact?`}
                  onConfirm={() => {
                    if (selectedUser) {
                      handleDeleteContact(selectedUser.id);
                    }    setShowDeleteModal(false);
                  }}
                onCancel={() => setShowDeleteModal(false)} 
      />
      </div>
      {!contactLoading && sortedContacts?.length > 0 && (
        <PaginationNav
          totalPages={totalPages}
          currentPage={queryParams.page}
          handlePageChange={handlePageChange}
        />
      )}
      <Modal show={advanceSearch} onHide={handleAdvanceSearchClose} centered className="wide-modal-dialog">
              <Modal.Header closeButton>
                <Modal.Title>Advanced Filter</Modal.Title>
              </Modal.Header>
              <Modal.Body className='advance-search'>
                <p>The AND condition is used to filter within the details of a single contact, while the OR condition is used to search across multiple contacts. However, using both conditions simultaneously may lead to logical conflicts if not structured properly.</p>
                <div className="content">
                  <div className="box mb-3">
                  {filters.map((filter, index) => {
                    const colSize = filter.selectedFilter === "CustomField" ? 6 : 4;
                    return (
                    <div className="item" key={index}>
                        {index > 0 && (
                      <div className="choose-option d-flex align-items-center justify-content-between">  
                        <span className="text">
                          <span 
                          className={`ml-2 ${filter.logicalOperator === 'AND' ? 'active' : ''}`}
                          onClick={() => handleFilterChange(index, 'logicalOperator', 'AND')}                        
                          >AND</span>
                          <span 
                          className={`ml-2 ${filter.logicalOperator === 'OR' ? 'active' : ''}`}
                          onClick={() => handleFilterChange(index, 'logicalOperator', 'OR')}
                          >OR</span>
                        </span>
                        <span onClick={() => removeFilter(index)}><FontAwesomeIcon icon={faCircleXmark} /></span> 
                      </div>
                        )}
                      <div className="">
                        <Row>
                          <Col className='mb-2' xl={colSize} lg={colSize} md={colSize} sm={colSize} xs={12}>
                            <Form.Group className="form-group" controlId="exampleForm.ControlInput1">
                              <Form.Label>Filter By</Form.Label>
                              <Form.Select aria-label="Default select example"
                              value={filter.selectedFilter}
                              onChange={(e) => handleFilterChange(index, 'selectedFilter', e.target.value)}
                              >
                                <option>Select</option>
                                <option value="Tags">Tags</option>
                                <option value="Email">Email</option>
                                <option value="FirstName">First Name</option>
                                <option value="Address">Address</option>
                                <option value="CustomField">Custom Field</option> 
                                <option value={LAST_CONTACT_ADDED_FILTER}>Last Contact Added</option>
                              </Form.Select>
                            </Form.Group>             
                          </Col>
                          
                          {filter.selectedFilter === "CustomField" && (
                            <Col className='mb-2' xl={colSize} lg={colSize} md={colSize} sm={colSize} xs={12}>
                              <Form.Group className="form-group" controlId="exampleForm.ControlInput1">
                                <Form.Label>Custom Field Name</Form.Label>
                                <Select
                                  options={
                                    predefinedFieldList.customFields?.map((field: any) => ({
                                      value: field.id,
                                      label: field.name
                                    })) || []
                                  }
                                  placeholder="Select custom field name"
                                  value={
                                    filter.customFieldName
                                      ? predefinedFieldList.customFields
                                          .map((field: any) => ({ value: field.id, label: field.name }))
                                          .find((option: any) => option.value === filter.customFieldName)
                                      : null
                                  }
                                  onChange={(selectedOption) =>
                                    handleFilterChange(index, 'customFieldName', selectedOption?.label || '')
                                  }
                                  isClearable
                                />
                              </Form.Group>             
                            </Col>
                          )}

                          <Col className='mb-2' xl={colSize} lg={colSize} md={colSize} sm={colSize} xs={12}>
                            <Form.Group className="form-group" controlId="exampleForm.ControlInput1">
                              <Form.Label>Matching Criteria</Form.Label>
                              <Form.Select aria-label="Default select example"
                                value={filter.selectedOperator}
                                onChange={(e) => handleFilterChange(index, 'selectedOperator', e.target.value)}
                              >
                                <option>Select</option>
                                {filter.selectedFilter === LAST_CONTACT_ADDED_FILTER ? (
                                  <>
                                    <option value="withinLastDays">Within last days</option>
                                    <option value="moreThanDaysAgo">More than days ago</option>
                                  </>
                                ) : filter.selectedFilter === 'CustomField' ? (() => {
                                  const cfType = (predefinedFieldList as any).customFields?.find(
                                    (cf: any) => cf.name === filter.customFieldName
                                  )?.type || 'text';
                                  return (
                                    <>
                                      <option value="Contains">Contains</option>
                                      <option value="DoesNotContain">Does not contain</option>
                                      <option value="isExactly">Is Exactly</option>
                                      <option value="notExactly">Not Exactly</option>
                                      {cfType === 'date' && (
                                        <>
                                          <option value="isBefore">Is Before</option>
                                          <option value="isAfter">Is After</option>
                                        </>
                                      )}
                                    </>
                                  );
                                })() : (
                                  <>
                                    <option value="Contains">contains</option>
                                    <option value="DoesNotContain">does not contain</option>
                                  </>
                                )}
                              </Form.Select>     
                            </Form.Group>
                          </Col>
                          <Col className='mb-2' xl={colSize} lg={colSize} md={colSize} sm={colSize} xs={12}>
                            <Form.Group className="form-group" controlId="formBasicEmail">
                            <Form.Label>Value</Form.Label>
                              {(() => {
                                const cfType = filter.selectedFilter === 'CustomField'
                                  ? (predefinedFieldList as any).customFields?.find(
                                      (cf: any) => cf.name === filter.customFieldName
                                    )?.type || 'text'
                                  : 'text';
                                if (filter.selectedFilter === 'CustomField' && cfType === 'boolean') {
                                  return (
                                    <Form.Select
                                      value={filter.inputValue}
                                      onChange={(e) => handleFilterChange(index, 'inputValue', e.target.value)}
                                    >
                                      <option value="">Select value</option>
                                      <option value="true">True</option>
                                      <option value="false">False</option>
                                    </Form.Select>
                                  );
                                }
                                return (
                                  <Form.Control
                                    type={filter.selectedFilter === 'CustomField' && cfType === 'date' ? 'date' : filter.selectedFilter === LAST_CONTACT_ADDED_FILTER ? 'number' : 'text'}
                                    min={filter.selectedFilter === LAST_CONTACT_ADDED_FILTER ? 1 : undefined}
                                    step={filter.selectedFilter === LAST_CONTACT_ADDED_FILTER ? 1 : undefined}
                                    placeholder={filter.selectedFilter === LAST_CONTACT_ADDED_FILTER ? 'Enter days (e.g. 90)' : 'Enter Value'}
                                    value={filter.inputValue}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                      handleFilterChange(index, 'inputValue', e.target.value)
                                    }
                                  />
                                );
                              })()}
                            </Form.Group>                            
                          </Col>
                        </Row>
                      </div>
                    </div>
                    )
                    })}
                    <Button
                      variant="primary"
                      type="submit"
                      className="btn-theme"
                      onClick={addFilter}
                    ><FontAwesomeIcon icon={faPlus} className='ms-0' /> Add Filter
                    </Button>                   
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer className='justify-content-between'>
                <Button variant="primary" className='btn-theme btn-border' onClick={handleAdvanceSearchClose}>
                  Discard
                </Button>
                <Button variant="primary" type="submit" className='btn-theme' onClick={handleAdvanceSearch}>
                  Search
                </Button>
              </Modal.Footer>
      </Modal>
      <Modal show={showCreateListModel} onHide={() => setShowCreateListModel(false)} centered>
      <Form  noValidate onSubmit={formik.handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Create New List</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group className="form-group" controlId="formBasicEmail">
                <Form.Label>List Name</Form.Label>
                <Form.Control type="text" placeholder="Enter"
                  name="listName"
                  value={formik.values.listName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  isInvalid={formik.touched.listName && !!formik.errors.listName}
                  required
                />
                <Form.Control.Feedback type="invalid">{formik.errors.listName}</Form.Control.Feedback>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
              <Button
                variant="primary"
                type="submit"
                className="btn-theme"
              >
              Save & Continue
                <FontAwesomeIcon icon={faPlay} />
              </Button>
            </Modal.Footer>
          </Form>
      </Modal>
      
      <Modal
        show={showExistingListModel}
        onHide={() => setShowExistingListModel(false)}
        centered
      >
        <Form noValidate onSubmit={existingListFormik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add To Existing List</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="form-group" controlId="formBasicEmail">
              <Form.Label>Select List</Form.Label>
                <Select
                  options={Object.values(listMap)}
                  closeMenuOnSelect={true}
                  onChange={(selected:any) => {
                    if (selected && selected.name) {
                      existingListFormik.setFieldValue('listName', selected.name);
                      setSelectedListId(selected.id)
                      setExistingContacts(selected?.contacts)
                    }
                  }}
                />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="justify-content-between">
            <XButton
              variant="primary"
              type="submit"
              buttonText={<>Save & Continue <FontAwesomeIcon icon={faPlay} /></>}
              loading={listLoading}
              loadingText={isExistingListSubmitting ? `${existingListProgress}% Processing...` : 'Loading...'}
              disabled={isExistingListSubmitting && existingListProgress >= 100}
            />
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal
        show={showUploadContactsModel}
        onHide={() => {
          if (isUploading) return;
          resetCsvUploadState();
          setShowUploadContactsModel(false);
          dispatch(clearData());
        }}
        centered
      >
        <Form noValidate onSubmit={uploadContactsFormik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Upload Contacts</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="form-group" controlId="formBasicEmail">
              <div className='d-flex justify-content-between align-items-center'>
                <Form.Label>Import Contacts </Form.Label>
                <Button className="csv-download-btn-style" onClick={downloadCsvFormat}>
                  <FontAwesomeIcon
                    icon={faFileArrowDown}
                    onClick={downloadCsvFormat}
                    className='me-2'
                  />
                  Download CSV Format 
                </Button>
              </div>
              <Form.Control 
                ref={fileInputRef}
                type="file" 
                onChange={(e) => handleFileChange(e.target as HTMLInputElement)} 
                accept=".csv"
              />
            </Form.Group>
            {/* Brands Functionality */}
            {/* {csvFile && (
            <Form.Group className="form-group" controlId="formBasicEmail">
              <Form.Label className="mb-0">Brands</Form.Label>
              <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip-top">
                        If no brand available. Click the icon to create a
                        brand. Once added, your brand will appear in the
                        dropdown, and you can select one for your contacts.
                      </Tooltip>
                    }
                  >
                    <span className="ms-2 cursor-pointer">
                      <FontAwesomeIcon
                        icon={faCircleInfo}
                        onClick={() => navigate("/org/settings/add-brand")}
                      />
                    </span>
                  </OverlayTrigger>
              <Form.Select
                aria-label="Default select example"
                {...uploadContactsFormik.getFieldProps("brand")}
              >
                <option value="">Optional</option>
                {brands.map((v: any) => (
                  <option key={`brand-${v.value}`} value={v.value}>
                    {v.text}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            )} */}
            {csvFile && (
            <div className="w-100 mt-3">
              <Alert variant="info" className="d-flex align-items-center mb-3 py-2 px-3 csv-mapping-info-banner">
                <FontAwesomeIcon icon={faCircleInfo} className="me-2 text-info fs-5 flex-shrink-0" />
                <div>
                  <div className="fw-semibold">Please map CSV fields with system fields</div>
                  <div className="small text-muted">
                    Match each column from your CSV file with an existing system field before saving. Unmapped fields will not be imported into the system.
                  </div>
                </div>
              </Alert>

              <div className='d-flex justify-content-between align-items-center mb-1'>
                <div className='d-flex w-100'>
                  <h6 className='w-50 mb-0'>CSV File Fields</h6>
                  <h6 className='w-50 mb-0'>Existing Fields</h6>
                </div>
              </div>
              {unmappedFields.length > 0 ? (
                <div className="text-warning small mb-3 fw-medium">
                  ⚠ {unmappedFields.length} of {csvFields.length} field{unmappedFields.length > 1 ? 's' : ''} currently unmapped
                </div>
              ) : (
                <div className="text-success small mb-3 fw-medium">
                  ✓ All {csvFields.length} fields mapped
                </div>
              )}
              <div className="d-flex flex-column">
                {csvFields.map((csvField: any, index: any) => (
                  <div
                    key={index}
                    className="d-flex mb-3 justify-content-between align-items-center"
                  >
                    {/* CSV Field label */}
                    <div className="csv-mapping-field">
                      <span>{csvField}</span>
                    </div>

                    <div className="d-flex justify-content-center align-items-center">
                      <FontAwesomeIcon icon={faArrowRight} className="mx-2" />
                    </div>

                    {/* Existing Fields dropdown */}
                    <div className="w-50">
                      <Form.Select
                        onChange={(e) =>
                        {const selectedValue = e.target.value;
                          if (selectedValue === "custom-field") {
                            setShowCustomFieldsModal(true);
                          } else {
                            handleFieldChange(csvField, selectedValue, index);
                          }}
                        }
                        className="form-select"
                        value={preselectedValue[index]?.databaseField || ""}
                      >
                        <option value="">Select a field</option>
                        {existingFields
                          .filter(
                            (option: any) =>
                              !Object.values(preselectedValue)
                                .map((mapped: any) => mapped.databaseField)
                                .includes(option) ||
                              preselectedValue[index]?.databaseField ===
                                option
                          )
                          .map((option: any, optionIndex: any) => (
                            <option key={optionIndex} value={option}>
                              {option}
                            </option>
                          ))}
                          <option value="custom-field" onClick={()=>{setShowCustomFieldsModal(true)}}>Add Custom Field</option>
                      </Form.Select>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            )}
          </Modal.Body>
          <Modal.Footer className="justify-content-between">
            <XButton
              variant="primary"
              type="submit"
              buttonText={<> Save & Continue<FontAwesomeIcon icon={faPlay}/> </>}
              loading={contactLoading}
              loadingText={isUploading ? `${uploadProgress}% Processing...` : 'Loading...'}
              disabled={isUploading && uploadProgress >= 100}
            /> 
          </Modal.Footer>
        </Form>
      </Modal>

      <XConfirm
        show={showCsvConfirmModal}
        onCancel={() => setShowCsvConfirmModal(false)}
        onConfirm={handleProceedUploadContacts}
        title="Confirm Field Mapping"
        className="csv-confirm-modal"
        confirmLabel="Yes, Save & Continue"
        cancelLabel="Review Mapping"
        message={
          <div>
            <p className="mb-2">
              Please make sure you have mapped all CSV fields with system fields before saving.
            </p>
            {unmappedFields.length > 0 ? (
              <div className="alert alert-warning py-2 px-3 mb-2 small">
                <strong>Notice:</strong> You have <strong>{unmappedFields.length}</strong> unmapped field{unmappedFields.length > 1 ? 's' : ''} ({unmappedFields.slice(0, 4).join(', ')}{unmappedFields.length > 4 ? ` and ${unmappedFields.length - 4} more` : ''}). Unmapped fields will not be imported.
              </div>
            ) : (
              <div className="alert alert-success py-2 px-3 mb-2 small">
                ✓ All CSV fields are successfully mapped to system fields.
              </div>
            )}
            <p className="mb-0 text-muted small">
              Are you sure you want to save and continue?
            </p>
          </div>
        }
      />

      {/* Custom Fields Modal */}
      <Modal
        show={showCustomFieldsModal}
        onHide={() => {
          customFieldsFormik.resetForm();
          setShowCustomFieldsModal(false)}
        }
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Custom Field</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={customFieldsFormik.handleSubmit}>
            <Row>
              <Col xl={6} md={6} xs={6}>
                <Form.Group>
                  <Form.Control
                    name="customFields[0].columnName"
                    type="text"
                    placeholder="Custom Name"
                    className="form-control mt-2"
                    value={customFieldsFormik.values.customFields[0].columnName}
                    onChange={customFieldsFormik.handleChange}
                    isInvalid={customFieldsFormik.touched.customFields && customFieldsFormik.touched.customFields[0] && !!((customFieldsFormik.errors.customFields as any)?.[0]?.columnName)}
                  />
                  <Form.Control.Feedback type="invalid">{((customFieldsFormik.errors.customFields as any)?.[0]?.columnName)}</Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xl={6} md={6} xs={6}>
                <Form.Group>
                  <Form.Select
                    name="customFields[0].columnType"
                    className="form-control mt-2"
                    value={customFieldsFormik.values.customFields[0]?.columnType}
                    onChange={customFieldsFormik.handleChange}
                    onBlur={customFieldsFormik.handleBlur}
                    isInvalid={customFieldsFormik.touched.customFields && customFieldsFormik.touched.customFields[0] && !!((customFieldsFormik.errors.customFields as any)?.[0]?.columnType)}
                  >
                    <option value="">Column Type</option>
                    {columnTypes.map((type, i) => (
                      <option key={i} value={type}>
                        {type}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">{((customFieldsFormik.errors.customFields as any)?.[0]?.columnType)}</Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <br/>
              <div className='d-flex justify-content-between align-items-center'>
                <XButton
                  variant="primary"
                  type="submit"
                  buttonText="Submit"
                />
              </div>
            <br/>
          </Form>
        </Modal.Body>
      </Modal>

      <XModal
        title='Add Contacts'
        body={
          <Form.Group className='d-flex align-items-center custom-radio-btns gap-3'>
            <Form.Check
                type="radio"
                label="Add Single Contact"
                className="d-flex align-items-center"
                name="add_contact_type"
                value="1"
                id="add_single_contact_radio"
                onChange={() => handleAddContactType(1)}
            />
            <Form.Check
                type="radio"
                label="Import Bulk Contacts"
                className="d-flex align-items-center"
                name="add_contact_type"
                value="2"
                id="import_bulk_contacts_radio"
                onChange={() => handleAddContactType(2)}
            />
          </Form.Group>
        }
        show={show}
        handleClose={() => setShow(false)}
      />
    </div>
  )
}

export default AllContacts;
